import { Injectable } from '@angular/core';
import { StorageConst } from 'app/config';
import { Customer } from 'app/models/customer';
import * as CryptoJS from 'crypto-js';
import { environment } from 'environments/environment';

@Injectable({
	providedIn: 'root'
})
export class StorageService {
	encryptionKey: string = '!!!!mmm_Enc_Key@@@@';
	storageApi = window.sessionStorage // localStorage;

	constructor() { }

	getItem(key: string): any {
		if (environment.production) {
			let item = this.storageApi.getItem(key);
			return item ? JSON.parse(this.decode(item)) : null;
		} else {
			let item = this.storageApi.getItem(key);
			return item ? JSON.parse(item) : null;
		}
	}

	setItem(key: string, value: any) {
		if (environment.production) {
			this.storageApi[key] = this.encode(JSON.stringify(value));
		} else {
			this.storageApi[key] = JSON.stringify(value);
		}
	}

	removeItem(key: string) {
		this.storageApi.removeItem(key);
	}

	getSessionToken(): string | null {
		return this.getItem(StorageConst.TOKEN);
	}

	setSessionToken(token: string) {
		this.setItem(StorageConst.TOKEN, token);
	}

	setCurrentCustomer(customer: Customer) {
		this.setItem(StorageConst.CURRENT_CUSTOMER, customer);
	}

	getCurrentCustomer(): Customer | null {
		return this.getItem(StorageConst.CURRENT_CUSTOMER);
	}

	setBooking(id: string) {
		this.setItem(StorageConst.BOOKING, id);
	}

	getBooking(): string | null {
		return this.getItem(StorageConst.BOOKING);
	}

	setTimer(time: string) {
		this.setItem(StorageConst.TIMER, time);
	}

	getTimer(): string | null {
		return this.getItem(StorageConst.TIMER);
	}

	clearLocalStorage() {
		this.storageApi.removeItem(StorageConst.CURRENT_CUSTOMER);
		this.storageApi.removeItem(StorageConst.TOKEN);
		this.storageApi.removeItem(StorageConst.BOOKING);
	}

	private encode(value: any) {
		return CryptoJS.AES.encrypt(value, this.encryptionKey).toString();
		// return window.btoa(value);
	}

	private decode(value: any) {
		return CryptoJS.AES.decrypt(value, this.encryptionKey).toString(CryptoJS.enc.Utf8);
		// return window.atob(value);
	}
}
